export const Rejected = () => (
  <svg fill="none" height="121" viewBox="0 0 121 121" width="121" xmlns="http://www.w3.org/2000/svg">
    <g id="Approval">
      <g id="approval--work-approval">
        <g id="documents">
          <path
            d="M55.7606 53.0385L49.5194 45.1839L31.544 40.8633L3.37402 57.1599L42.3746 106.264L80.4902 84.1617L72.8792 74.5827"
            id="Vector"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M39.5052 50.9567L29.6616 41.9405L31.5438 40.8521L39.5052 50.9567Z" fill="#1072BA" id="Vector_2" />
          <path
            d="M39.5052 50.9567L29.6616 41.9405L31.5438 40.8521L39.5052 50.9567Z"
            id="Vector_3"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M56.777 76.2688C52.13 73.591 49.4168 69.0592 49.4714 64.837C46.1758 64.1014 42.7251 64.5934 39.7664 66.2206C33.7556 69.7006 32.7464 77.4028 37.5206 83.4022C42.2948 89.4124 51.0386 91.4542 57.0494 87.9622C58.7574 87.0074 60.1572 85.5845 61.084 83.861C62.0108 82.1376 62.426 80.1852 62.2808 78.2338C60.3412 77.9218 58.4755 77.2558 56.777 76.2688Z"
            fill="#FF4A4A"
            id="Vector_4"
          />
          <path
            d="M56.777 76.2688C52.13 73.591 49.4168 69.0592 49.4714 64.837C46.1758 64.1014 42.7251 64.5934 39.7664 66.2206C33.7556 69.7006 32.7464 77.4028 37.5206 83.4022C42.2948 89.4124 51.0386 91.4542 57.0494 87.9622C58.7574 87.0074 60.1572 85.5845 61.084 83.861C62.0108 82.1376 62.426 80.1852 62.2808 78.2338C60.3412 77.9218 58.4755 77.2558 56.777 76.2688Z"
            id="Vector_5"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.5079 45.1613L39.5053 50.9567L31.5439 40.8521"
            id="Vector_6"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.2139 60.9699L31.9641 51.2739"
            id="Vector_7"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.4414 67.5708L46.5024 52.4868"
            id="Vector_8"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M38.374 74.5556L48.374 76.6636L48.0157 68.6636"
            id="Vector_9"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58.4314 78.7712L48.3741 76.9562L48.966 84.9423"
            id="Vector_9_2"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g id="hand">
          <path
            d="M53.2158 56.0825L50.6418 60.5057C47.7156 65.5631 50.4618 72.6257 56.7768 76.2689C62.4336 79.5437 69.9768 79.3403 73.527 73.6607L76.0542 69.2771"
            id="Vector_10"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.5902 51.9697C55.4527 52.8886 53.764 54.6134 52.8904 56.7697C50.7208 62.1025 54.1906 68.3401 59.5666 71.4373C64.3522 74.2009 70.6012 74.4679 74.491 71.0515C75.0849 70.5304 75.6092 69.9349 76.051 69.2797"
            id="Vector_11"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.8991 34.2971L89.0863 39.1511C88.0435 40.9655 85.8319 41.9177 83.3593 41.9177C76.1233 41.9177 70.2019 34.4645 72.8923 29.8061L75.6931 24.9521C74.4229 27.1637 75.1603 29.8853 76.5667 31.9385C80.6581 37.9133 89.3791 38.6345 91.8991 34.2971Z"
            id="Vector_12"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.992 53.44C98.4914 60.6826 91.5686 68.9008 85.9454 73.3996C83.9711 73.1007 82.0428 72.5519 80.207 71.7664C76.6424 69.9788 73.4576 67.5179 70.8284 64.5196L74.8652 57.5794C74.2157 56.3999 73.6253 55.1888 73.0964 53.9506C72.5476 54.2179 71.9296 54.3088 71.327 54.211C72.257 57.2278 70.9532 58.498 68.9342 58.237C69.8078 61.0384 67.8116 62.197 65.0786 61.1518C65.4638 63.3628 62.2928 63.6946 59.7482 61.5598C57.725 59.8618 54.506 55.0648 56.6882 52.9198C56.9634 52.6529 57.3173 52.4818 57.6974 52.432C57.2894 50.878 57.3974 49.3084 58.9112 48.3946C59.16 48.2407 59.4381 48.1404 59.7278 48.1C59.294 45.6706 60.5726 43.9888 62.4494 43.4386C62.4674 42.8224 62.645 42.2214 62.9648 41.6944C63.2846 41.1674 63.7357 40.7324 64.274 40.432C63.3176 38.9598 62.5731 37.3603 62.0624 35.6806C61.481 33.2854 63.3224 31.8652 65.771 33.7528C66.5774 34.375 67.6418 35.272 68.912 36.304C69.2636 36.1 72.5864 34.4668 72.5864 34.4668C72.7166 34.8724 72.8798 35.2672 73.0742 35.6464C73.0742 35.6464 72.4742 36.6898 71.5094 38.3344C74.6054 40.648 78.4268 43.12 82.4984 44.458L83.9612 41.938C85.6844 41.8947 87.3232 41.1831 88.5314 39.9538C92.3474 43.2988 90.5036 41.5114 101.992 53.44Z"
            id="Vector_13"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.733 36.2819C84.1638 39.1169 75.4074 34.0217 75.0582 27.8327C74.8596 24.3179 77.6982 22.1855 81.4182 22.1855C85.8072 22.1855 90.4476 25.1825 92.022 29.2055C93.1464 32.0741 92.4834 34.8815 89.733 36.2819Z"
            fill="#1072BA"
            id="Vector_14"
          />
          <path
            d="M89.733 36.2819C84.1638 39.1169 75.4074 34.0217 75.0582 27.8327C74.8596 24.3179 77.6982 22.1855 81.4182 22.1855C85.8072 22.1855 90.4476 25.1825 92.022 29.2055C93.1464 32.0741 92.4834 34.8815 89.733 36.2819Z"
            id="Vector_15"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M80.2181 71.7642C79.4015 73.8174 79.2653 75.3042 79.9571 75.8808C80.8871 76.6524 83.1323 75.6312 85.9571 73.3974C83.9929 73.0524 82.0696 72.5051 80.2181 71.7642Z"
            fill="#1072BA"
            id="Vector_16"
          />
          <path
            d="M80.2181 71.7642C79.4015 73.8174 79.2653 75.3042 79.9571 75.8808C80.8871 76.6524 83.1323 75.6312 85.9571 73.3974C83.9929 73.0524 82.0696 72.5051 80.2181 71.7642Z"
            id="Vector_17"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.3066 49.6073L101.992 53.4401C104.502 47.9621 102.665 46.6769 98.3066 49.6073Z"
            fill="#1072BA"
            id="Vector_18"
          />
          <path
            d="M98.3066 49.6073L101.992 53.4401C104.502 47.9621 102.665 46.6769 98.3066 49.6073Z"
            id="Vector_19"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.0445 69.2715C75.8057 69.6447 75.5363 69.9975 75.2393 70.3263L70.8281 64.5195C72.3838 66.2935 74.1336 67.8875 76.0445 69.2715Z"
            fill="#1072BA"
            id="Vector_20"
          />
          <path
            d="M76.0445 69.2715C75.8057 69.6447 75.5363 69.9975 75.2393 70.3263L70.8281 64.5195C72.3838 66.2935 74.1336 67.8875 76.0445 69.2715Z"
            id="Vector_21"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M109.999 61.1404C110.002 61.3426 109.966 61.5435 109.891 61.7314C109.817 61.9193 109.705 62.0905 109.564 62.2349C109.422 62.3792 109.253 62.4939 109.067 62.5722C108.88 62.6504 108.68 62.6907 108.478 62.6907C108.276 62.6907 108.076 62.6503 107.889 62.5719C107.703 62.4936 107.534 62.3789 107.392 62.2344C107.251 62.09 107.14 61.9188 107.065 61.7309C106.991 61.5429 106.954 61.342 106.958 61.1398C106.966 60.7419 107.13 60.3629 107.414 60.0844C107.699 59.8058 108.081 59.6498 108.479 59.6499C108.877 59.65 109.259 59.8061 109.543 60.0848C109.827 60.3635 109.991 60.7425 109.999 61.1404Z"
            fill="#1072BA"
            id="Vector_22"
          />
          <path
            d="M109.999 61.1404C110.002 61.3426 109.966 61.5435 109.891 61.7314C109.817 61.9193 109.705 62.0905 109.564 62.2349C109.422 62.3792 109.253 62.4939 109.067 62.5722C108.88 62.6504 108.68 62.6907 108.478 62.6907C108.276 62.6907 108.076 62.6503 107.889 62.5719C107.703 62.4936 107.534 62.3789 107.392 62.2344C107.251 62.09 107.14 61.9188 107.065 61.7309C106.991 61.5429 106.954 61.342 106.958 61.1398C106.966 60.7419 107.13 60.3629 107.414 60.0844C107.699 59.8058 108.081 59.6498 108.479 59.6499C108.877 59.65 109.259 59.8061 109.543 60.0848C109.827 60.3635 109.991 60.7425 109.999 61.1404Z"
            id="Vector_23"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.9718 41.9068C81.7513 41.9741 79.556 41.4207 77.6328 40.3088C75.7095 39.197 74.1345 37.5707 73.0848 35.6128C73.0848 35.6128 72.4848 36.6556 71.52 38.3008C74.616 40.6138 78.4374 43.0858 82.509 44.4244L83.9718 41.9068Z"
            fill="#2ED3AE"
            id="Vector_24"
          />
          <path
            d="M83.9718 41.9068C81.7513 41.9741 79.556 41.4207 77.6328 40.3088C75.7095 39.197 74.1345 37.5707 73.0848 35.6128C73.0848 35.6128 72.4848 36.6556 71.52 38.3008C74.616 40.6138 78.4374 43.0858 82.509 44.4244L83.9718 41.9068Z"
            fill="#1072BA"
            id="Vector_25"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.854 57.5795C74.204 56.4002 73.6135 55.189 73.0846 53.9507C72.5358 54.218 71.9177 54.3089 71.3152 54.2111C72.2452 57.2279 70.9414 58.4981 68.9224 58.2371C69.796 61.0385 67.7998 62.1971 65.0668 61.1519C65.4526 63.3629 62.281 63.6947 59.7364 61.5599C59.6164 61.4567 59.476 61.3199 59.3164 61.1747C59.9775 63.0045 61.2897 64.5264 63.0022 65.4497C65.269 66.7541 69.0964 67.3775 70.3282 65.3249L74.854 57.5795Z"
            fill="#1072BA"
            id="Vector_26"
          />
          <path
            d="M74.854 57.5795C74.204 56.4002 73.6135 55.189 73.0846 53.9507C72.5358 54.218 71.9177 54.3089 71.3152 54.2111C72.2452 57.2279 70.9414 58.4981 68.9224 58.2371C69.796 61.0385 67.7998 62.1971 65.0668 61.1519C65.4526 63.3629 62.281 63.6947 59.7364 61.5599C59.6164 61.4567 59.476 61.3199 59.3164 61.1747C59.9775 63.0045 61.2897 64.5264 63.0022 65.4497C65.269 66.7541 69.0964 67.3775 70.3282 65.3249L74.854 57.5795Z"
            id="Vector_27"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.854 57.5796C76.2484 60.0744 78.0634 62.49 80.1496 63.3744"
            id="Vector_28"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.5199 38.3004C68.8481 36.3048 67.5887 35.115 65.7815 33.7302C63.3365 31.8564 61.4975 33.2646 62.0729 35.658C63.0551 39.741 69.1799 47.5806 71.8715 50.7414C71.8715 50.7414 72.3023 52.1022 73.0961 53.9508"
            id="Vector_29"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.9202 45.3641C85.4144 45.2233 83.9302 44.9076 82.4976 44.4233"
            id="Vector_30"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.7031 47.9058C60.1903 51.195 63.5113 54.8712 64.4545 55.7766C65.6604 57.0342 67.2246 57.8894 68.9341 58.2258"
            id="Vector_31"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M73.0937 53.9509C71.7893 54.6199 69.5903 54.2107 67.0607 51.8755C65.8925 50.7955 62.3429 46.6555 62.4563 43.4155"
            id="Vector_32"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.707 52.4194C58.3532 54.8464 60.3368 57.4444 61.1432 58.3162C62.227 59.5433 63.5716 60.5122 65.0786 61.1518"
            id="Vector_33"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M102.684 48.3145L116.78 60.4831"
            id="Vector_34"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.9688 75.8945L93.2258 87.4847"
            id="Vector_35"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g id="elements">
          <path
            d="M80.6034 97.2041C80.8931 97.2039 81.1763 97.2895 81.4172 97.4503C81.6581 97.611 81.8459 97.8396 81.9569 98.1072C82.0679 98.3747 82.097 98.6691 82.0406 98.9532C81.9842 99.2373 81.8448 99.4983 81.64 99.7031C81.4353 99.9079 81.1744 100.047 80.8903 100.104C80.6062 100.16 80.3118 100.131 80.0442 100.021C79.7767 99.9097 79.548 99.722 79.3871 99.4811C79.2263 99.2403 79.1405 98.9571 79.1406 98.6675C79.1416 98.2798 79.296 97.9082 79.5701 97.634C79.8442 97.3598 80.2157 97.2052 80.6034 97.2041Z"
            id="Vector_36"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
          <path
            d="M48.4191 15.0635L48.4077 24.9521"
            id="Vector_37"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
          <path
            d="M53.3635 20.0191L43.4629 20.0083"
            id="Vector_38"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
          <path
            d="M105.123 31.3599L106.132 33.3897L108.366 33.7185L106.744 35.2947L107.13 37.5291L105.123 36.4743L103.126 37.5291L103.501 35.2947L101.879 33.7185L104.124 33.3897L105.123 31.3599Z"
            id="Vector_39"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
        </g>
      </g>
    </g>
  </svg>
);
